import React from "react";
import StaffProfileCard from "../../../Staff/partials/StaffProfileCard";
import renderHTML from "react-render-html";
import { cleanDate } from "../../../../util/app";

const NoteDetail = ({ item }) => {
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="row">
                        <div className="col-4 bg-primary">
                            <h5>Status</h5>
                        </div>
                    </div>
                    <div className="col-12">
                        <table className="table table-bordered">
                            <tbody>
                                <tr>
                                    <th>
                                        <strong>Staff</strong>
                                        <br />
                                        <StaffProfileCard item={item.author} />
                                    </th>
                                    {item.confirm.status && (
                                        <th>
                                            <strong>Confirmed By</strong>
                                            <br />
                                            <StaffProfileCard item={item.confirm.author} />
                                        </th>
                                    )}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                {item.notes.map((note, idx) => (
                    <div className="col-12" key={idx}>
                        <div className="row">
                            <div className="col-4 bg-primary">
                                <h5>Clinical Note {idx + 1}</h5>
                            </div>
                        </div>
                        <div className="col-12">
                            <table className="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Summary</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>{note.summary}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Category</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>{note.category.name}</td>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>Date & Time</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>{cleanDate(parseInt(note.datetime))}</td>
                                    </tr>

                                    <tr>
                                        <td style={{ width: "40%" }}>
                                            <strong>NOTE</strong>
                                        </td>
                                        <td style={{ width: "60%" }}>
                                            <span>{renderHTML(note.note)}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
};

export default NoteDetail;
